import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveBounce16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMoveBounce16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M10.737 1.94a3.6 3.6 0 0 1 3.6 3.6l-.004.185a3.6 3.6 0 0 1-3.596 3.415l-.184-.005a4 4 0 0 1-.535-.068l-1.89 3.492h4.79a.6.6 0 1 1 0 1.2H3.079a.6.6 0 0 1 0-1.2h2.274l-2.119-3.17a.599.599 0 1 1 .997-.667l2.547 3.813L8.891 8.63a3.6 3.6 0 0 1 1.847-6.69m0 1.2a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8m-9.01 2.822a.6.6 0 0 1 .833.165l.377.567a.6.6 0 1 1-.997.666l-.377-.566a.6.6 0 0 1 .165-.832"
            />
        </svg>
    );
}
export default memo(IconMoveBounce16);
